import Footer from "./components/Footer.js";
import Navbar from "./components/Navbar.js";
import GoToDashboardButton from "./components/GoToDashBoard.js";
import ScrollToTop from "./components/scroll/index.js";

const Layout = ({ children }) => {
  return (
    <>
      <div>
      <ScrollToTop />
        <Navbar />
        {children}
        <GoToDashboardButton />
      </div>
      <Footer />
    </>
  );
};
export default Layout;
